import { createSlice, current } from '@reduxjs/toolkit';

const initialState = {
  appLoaded: false,
  wrapperClass: '',
  blockingNavigation: {
    isBlocking: false,
    shouldRevalidateNav: false,
  },
};

export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setAppLoaded: (state, action) => {
      state.appLoaded = action.payload;
    },
    addWrapperClass: (state, action) => {
      const { wrapperClass } = current(state);
      state.wrapperClass = `${wrapperClass} ${action.payload}`;
    },
    removeWrapperClass: (state, action) => {
      const { wrapperClass } = current(state);
      state.wrapperClass = wrapperClass.replace(action.payload, '');
    },
    cleanApplicationSlice() {
      return initialState;
    },
    setIsBlocking: (state, action) => {
      state.blockingNavigation = action.payload;
    },
  },
});

export const {
  addWrapperClass,
  cleanApplicationSlice,
  removeWrapperClass,
  setAppLoaded,
  setIsBlocking,
} = applicationSlice.actions;

export default applicationSlice.reducer;
